<template>
  <div class="column content-box settings--content">
    <label class="step-title">{{
      $t('INTEGRATION_SETTINGS.ASSISTENT.FORM.TEAMS.TITLE')
    }}</label>
    <div v-for="(item, index) in teams" :key="index" class="label-entry">
      <accordion-item
        :title="itemTitle(item)"
        :is-open="openAccordions[index]"
        @click="toggleAccordion(index)"
      >
        <label>
          {{ $t('INTEGRATION_SETTINGS.ASSISTENT.FORM.TEAMS.LABEL_ID') }}
        </label>
        <multiselect
          v-model="item.selectedTeam"
          track-by="id"
          label="name"
          :placeholder="
            $t('INTEGRATION_SETTINGS.ASSISTENT.FORM.TEAMS.SELECT_TEAM')
          "
          :multiple="false"
          selected-label
          :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
          :deselect-label="
            $t('INTEGRATION_SETTINGS.ASSISTENT.FORM.TEAMS.DESELECT_TEAM')
          "
          :close-on-select="true"
          :options="getAvailableTeams(index)"
          :allow-empty="true"
        >
          <template v-slot:noResult>
            {{
              $t('INTEGRATION_SETTINGS.ASSISTENT.FORM.TEAMS.NOT_TEAMS_FOUND')
            }}
          </template>
        </multiselect>
        <label>
          {{
            $t('INTEGRATION_SETTINGS.ASSISTENT.FORM.TEAMS.LABEL_INSTRUCTION')
          }}
          <textarea
            v-model.trim="item.instruction"
            name="teams_instruction"
            class="textlong"
            :placeholder="
              $t(
                'INTEGRATION_SETTINGS.ASSISTENT.FORM.TEAMS.PLACEHOLDER_INSTRUCTION'
              )
            "
          />
        </label>
        <woot-button
          variant="clear"
          color-scheme="alert"
          icon="dismiss"
          size="small"
          type="button"
          @click="removeItem(index)"
        >
          {{
            $t('INTEGRATION_SETTINGS.ASSISTENT.FORM.TEAMS.BUTTON_REMOVE_TEXT')
          }}
        </woot-button>
      </accordion-item>
    </div>
    <woot-button
      v-if="
        teams.length < teamsList.length &&
          getAvailableTeams(teams.length).length > 0
      "
      type="button"
      class="button--add-domain"
      icon="add"
      color-scheme="success"
      variant="smooth"
      size="small"
      @click="addItem"
    >
      <span>{{
        $t('INTEGRATION_SETTINGS.ASSISTENT.FORM.TEAMS.BUTTON_ADD_TEXT')
      }}</span>
    </woot-button>

    <div class="tab-footer">
      <woot-submit-button
        :loading="isSaving"
        :button-text="$t('INTEGRATION_SETTINGS.ASSISTENT.UPDATE.BUTTON_TEXT')"
        @click="onSubmit"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import assistentTabMixin from '../../mixins/assistentTabMixin';
import AccordionItem from '../../../profile/components/AccordionItem.vue';

const safeParse = val => {
  if (!val) return [];
  if (typeof val === 'object') return val;
  try {
    return JSON.parse(val);
  } catch (e) {
    return [];
  }
};

export default {
  components: { AccordionItem },
  mixins: [assistentTabMixin],
  data() {
    return {
      teams: [],
      openAccordions: [],
    };
  },
  computed: {
    ...mapGetters({
      teamsList: 'teams/getTeams',
    }),
  },
  async created() {
    await this.$store.dispatch('teams/get');
    this.hydrate();
  },
  methods: {
    itemTitle(item) {
      if (item.selectedTeam) {
        return `${this.$t(
          'INTEGRATION_SETTINGS.ASSISTENT.FORM.TEAMS.ITEM_PREFIX'
        )} ${item.selectedTeam.name}`;
      }
      return this.$t(
        'INTEGRATION_SETTINGS.ASSISTENT.FORM.TEAMS.NEW_ITEM_TITLE'
      );
    },
    hydrate() {
      const dbTeams = safeParse(this.assistent.teams);
      this.teams = dbTeams.map(dbItem => {
        const fullTeam = this.teamsList.find(
          t => String(t.id) === String(dbItem.id)
        );
        return {
          selectedTeam: fullTeam,
          instruction: dbItem.instruction,
        };
      });
      this.openAccordions = this.teams.map(() => false);
    },
    getAvailableTeams(currentIndex) {
      const selectedInOtherRows = this.teams
        .filter((item, index) => index !== currentIndex && item.selectedTeam)
        .map(item => item.selectedTeam.id);

      return this.teamsList.filter(
        team => !selectedInOtherRows.includes(team.id)
      );
    },
    toggleAccordion(index) {
      this.$set(this.openAccordions, index, !this.openAccordions[index]);
    },
    addItem() {
      this.teams.push({ selectedTeam: null, instruction: '' });
      this.openAccordions = this.openAccordions.map(() => false);
      this.openAccordions.push(true);
    },
    removeItem(index) {
      this.teams.splice(index, 1);
      this.openAccordions.splice(index, 1);
    },
    async onSubmit() {
      const mappedTeams = this.teams
        .filter(item => item.selectedTeam)
        .map(item => ({
          id: item.selectedTeam.id,
          instruction: item.instruction,
        }));

      await this.saveAssistent({ teams: JSON.stringify(mappedTeams) });
    },
  },
};
</script>

<style scoped lang="scss">
@import './tabs-shared.scss';
</style>
